import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import './CloseModalMap.css';
import Button from '@components/common/Button';


interface ModalProps {
  closeModal: (value: boolean) => void;
  showModal: boolean;
}
const CloseModalMap: React.FC<ModalProps> = ({
  closeModal,
  showModal,
}) => {
  const closeYes = () => {
    closeModal(true);
  }
  const closeNo = () => {
    closeModal(false);
  }
  return (
    <>
      <Modal
        show={showModal}
        onHide={closeNo}
        backdrop="static"
        keyboard={false}
        dialogClassName="custom_modal_page_map"
      >

        <Modal.Body className="page_modal_body">
          <div className="modal_title">Address is manually modified. Do you want to override the address from the map based on the current action ?</div>
          <div className="modal_page_body">
            <Button
              onClick={closeYes}
              disabled={false}
              id=""
              buttonName={'Yes'}
              colorType={'save'}
              icon={''}
              iconPosition={''}
            />
            <Button
              onClick={closeNo}
              disabled={false}
              id=""
              buttonName={'No'}
              colorType={'disabled'}
              icon={''}
              iconPosition={''}
            />
          </div>

        </Modal.Body>

      </Modal>
    </>
  );
};

export default CloseModalMap;
